import { render, staticRenderFns } from "./PaymentLanding.vue?vue&type=template&id=6e20eefd&scoped=true&"
import script from "./PaymentLanding.vue?vue&type=script&lang=js&"
export * from "./PaymentLanding.vue?vue&type=script&lang=js&"
import style0 from "./PaymentLanding.vue?vue&type=style&index=0&id=6e20eefd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e20eefd",
  null
  
)

export default component.exports